<template>
  <v-container>
    <page-header-title :title="$t('fe.enrolment.title') + ' ' + page_title" class="enr-title mb-4"></page-header-title>

    <v-form ref="form" v-if="course.id">
      <v-container grid-list-md class="pa-0">
        <v-layout wrap>
          <v-flex xs12>
            <v-card>
              <v-card-text class="pa-4 enr-course-description">
                <div v-if="course.short_description && course.short_description.length > 500">
                  <div v-if="!readMoreActivatedShort">
                    <span style="white-space: break-spaces">{{ course.short_description.slice(0, 500) + "... " }}</span>
                  </div>
                  <a class="" v-if="!readMoreActivatedShort" @click="readMoreActivatedShort = !readMoreActivatedShort" href="#"
                    >{{ $t("global.show_more") }}...</a
                  >

                  <div v-if="readMoreActivatedShort">
                    <span style="white-space: break-spaces">{{ course.short_description }}</span>
                  </div>
                  <a class="" v-if="readMoreActivatedShort" @click="readMoreActivatedShort = !readMoreActivatedShort" href="#"
                    >{{ $t("global.show_less") }}...</a
                  >
                </div>
                <div v-if="course.short_description && course.short_description.length <= 500">
                  <div>
                    <span style="white-space: break-spaces">{{ course.short_description }}</span>
                  </div>
                </div>
              </v-card-text>
            </v-card>

            <v-card>
              <v-card-text class="pa-4 mt-2 mb-2 enr-course-description">
                <div v-if="course.description && course.description.length > 500">
                  <div v-if="!readMoreActivated">
                    <span style="white-space: break-spaces">{{ course.description.slice(0, 500) + "... " }}</span>
                  </div>
                  <a class="" v-if="!readMoreActivated" @click="readMoreActivated = !readMoreActivated" href="#"
                    >{{ $t("global.show_more") }}...</a
                  >

                  <div v-if="readMoreActivated">
                    <span style="white-space: break-spaces">{{ course.description }}</span>
                  </div>
                  <a class="" v-if="readMoreActivated" @click="readMoreActivated = !readMoreActivated" href="#"
                    >{{ $t("global.show_less") }}...</a
                  >
                </div>
                <div v-if="course.description && course.description.length <= 500">
                  <div>
                    <span style="white-space: break-spaces">{{ course.description }}</span>
                  </div>
                </div>
              </v-card-text>
            </v-card>

            <v-card v-if="courses">
              <v-card-text class="pa-4 enr-course-description">
                <p class="font-weight-bold" v-if="!cid">{{ $t("enrolments.select_course_title") }}</p>
                <p class="font-weight-bold" v-else>{{ $t("fe.enrolment.date_and_place") }}</p>

                <v-radio-group v-model="selectedCourse" name="courses-selection" v-if="!cid">
                  <v-radio v-for="course in courses" :key="course.uuid" :label="course.custom_name_2" :value="course.id" class="course-item"></v-radio>
                </v-radio-group>
                <v-else>
                    <p>{{ course.custom_name_3 }}</p>
                </v-else>

                <p class="font-weight-bold mt-4">{{ $t("enrolments.select_enrolment_type") }}</p>
                <v-btn :disabled="!selectedCourse" @click="show('organisation')" color="primary" class="darken-2 ml-0">{{
                  $t("fe.enrolment.select_organisation")
                }}</v-btn>
                <v-btn :disabled="!selectedCourse" @click="show('personal')" color="primary" class="darken-2">{{
                  $t("fe.enrolment.select_personal")
                }}</v-btn>
              </v-card-text>
            </v-card>
          </v-flex>
          <!-- courses -->
        </v-layout>
      </v-container>
    </v-form>
  </v-container>
</template>

<script>
export default {
  name: "Enrolment",

  props: ["id", "locale", "cid"],

  data() {
    return {
      page_title: "",

      coursetemplate: {},
      course: {},
      courses: [],
      selectedCourse: null,

      readMoreActivated: false,
      readMoreActivatedShort: false
    }
  },

  created() {
    let vm = this
    let query_published = this.$route.query.published

    this.$updateSetting("fe_locale", this.locale)
    this.$i18n.locale = this.locale

    axios
      .get(this.API_URL + "open/organisation/my")
      .then((res) => {
        let data = res.data.data
        this.$store.dispatch("frontend/setOrganisation", data)

        this.$setTenantInAxiosHeader(data.tenant_id)

        axios.get(this.API_URL + "open/coursetemplate/uuid/" + this.id).then((res) => {
          this.coursetemplate = res.data.data

          let query =
            this.API_URL +
            "open/courses?show_all=true&resourcetype=course-basic-list&query_coursetemplate_id=" +
            this.coursetemplate.id +
            (query_published == "true" ? "&query_is_published=1" : "") +
            "&sort_by=start_datetime&&sort_order=asc"

          if (this.cid) {
            query += "&query_uuid=" + this.cid
          }

          axios.get(query).then((res) => {
            this.courses = res.data.data.filter((c) => {
              let start_date = vm.moment(c.start_date)
              let today_date = vm.moment()

              return today_date.isSameOrBefore(start_date, "day")
            })

            if (this.courses.length > 0) {
              if (this.cid) {
                let course = this.courses.find((i) => i.uuid == this.cid)
                if (course) {
                  this.course = course
                  this.page_title = this.course.name
                  this.selectedCourse = this.course.id

                  let available_enrolment = this.course.num_places - this.course.num_enrolled
                  if (
                    (this.course && !this.course.allow_overbook && Boolean(available_enrolment <= 0)) ||
                    (this.course && this.moment(this.course.enrolment_due_date).diff(this.moment(), "days") < 0)
                  ) {
                    this.$router.push("/f/" + this.locale + "/enrolment/personal/interest")
                    this.fields_disabled = true
                  }
                } else {
                  this.$router.push("/f/" + this.locale + "/enrolment/personal/interest")
                }
              } else {
                this.$router.push("/f/" + this.locale + "/enrolment/personal/interest")
              }
            } else {
              this.$router.push("/f/" + this.locale + "/enrolment/personal/interest")
            }
          })
        })
      })
      .catch((err) => console.log(err))
  },

  methods: {
    show(type) {
      if (this.selectedCourse) {
        let course = this.courses.find((i) => i.id == this.selectedCourse)

        if (course) {
          if (type == "organisation") {
            this.$router.push("/f/" + this.locale + "/enrolment/organisation/course/" + course.uuid)
          }

          if (type == "personal") {
            this.$router.push("/f/" + this.locale + "/enrolment/personal/course/" + course.uuid)
          }
        }
      }
    }
  }
}
</script>

<style>
.course-item label {
  font-size: 1em !important;
}
</style>
